// Import model
import { TagsFieldOptions } from '../models/TagsFieldOptions';

// Import base class serializer
import { FieldOptionsSerializer } from './FieldOptionsSerializer';

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for TagsFieldOptions - handles JSON serialization and deserialization with type validation
 */
export class TagsFieldOptionsSerializer {
  /**
   * Deserializes a JSON string into a TagsFieldOptions instance
   */
  static deserialize(json: string): TagsFieldOptions {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a TagsFieldOptions instance
   */
  static fromObject(obj: any): TagsFieldOptions {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to TagsFieldOptions');
    }


    const instance: TagsFieldOptions = {
      t: obj['_t'] as string,
      linkUrl: obj['LinkUrl'] as string | undefined,
      linkLabel: obj['LinkLabel'] as string | undefined,
      url: obj['Url'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of TagsFieldOptions instances
   */
  static deserializeArray(json: string): TagsFieldOptions[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a TagsFieldOptions instance to a JSON string
   */
  static serialize(instance: TagsFieldOptions): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a TagsFieldOptions instance to a plain object
   */
  static toObject(instance: TagsFieldOptions): any {
    return {
      '_t': instance.t,
      'LinkUrl': instance.linkUrl,
      'LinkLabel': instance.linkLabel,
      'Url': instance.url,
    };
  }

  /**
   * Serializes an array of TagsFieldOptions instances to a JSON string
   */
  static serializeArray(instances: TagsFieldOptions[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
